import {GetAddressByZipCodeRequest} from 'domain/usecases/private/profile/get-address-by-zipcode';
import {makeGetAddressByZipCode} from 'main/factories/usecases';

export async function getAddressByZipCode(params: GetAddressByZipCodeRequest) {
	const response = await makeGetAddressByZipCode().get(params);

	return response;
}
